import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginatedProviderDetailResponse, PaginatedTransitProgramProviderResponse, ProviderDetail } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ProviderService extends UzurvRestService {
  readonly resourceUrl = 'providers/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  findById(id: number): Observable<ProviderDetail> {
    return this.get<ProviderDetail>(`${this.resourceUrl}${id}`).pipe(map(response => Deserialize(response, ProviderDetail)));
  }

  listActiveProviders(pageNumber: number, pageSize: number): Observable<PaginatedProviderDetailResponse> {
    return this.get(this.resourceUrl, {
      pageNumber,
      pageSize
    }).pipe(map(response => Deserialize(response, PaginatedProviderDetailResponse)));
  }

  searchProviders(
    searchString: string,
    pageNumber: number,
    pageSize: number,
    statusIds?: Array<number>,
    transitProgramIds?: Array<number>
  ): Observable<PaginatedProviderDetailResponse> {
    return this.get(`search/${this.resourceUrl}`, {
      searchString,
      pageNumber,
      pageSize,
      statusIds,
      transitProgramIds
    }).pipe(map(response => Deserialize(response, PaginatedProviderDetailResponse)));
  }

  protected getApiUrl(): string {
    return this.uzurvRestConfiguration.dotsApiUrl;
  }

  listTransitProgramProviders(
    providerId: number,
    pageNumber: number,
    pageSize: number
  ): Observable<PaginatedTransitProgramProviderResponse> {
    return this.get(`${this.resourceUrl}${providerId}/transitProgramProviders`, {
      providerId,
      pageNumber,
      pageSize
    }).pipe(map(response => Deserialize(response, PaginatedTransitProgramProviderResponse)));
  }
}
